import { __extends } from "tslib";
import { AssetEvent } from '@awayjs/core';
import { BlendMode, ContextGLCompareMode } from '@awayjs/stage';
import { ShaderBase } from './ShaderBase';
import { _Render_MaterialPassBase } from './_Render_MaterialPassBase';
var _Render_RendererMaterial = /** @class */ (function (_super) {
    __extends(_Render_RendererMaterial, _super);
    function _Render_RendererMaterial(renderer, renderElements) {
        var _this = _super.call(this, renderer, renderElements) || this;
        _this._renderer = renderer;
        _this._shader = new ShaderBase(renderElements, _this, _this, _this._stage);
        _this._texture = _this._renderer.texture.getAbstraction(_this._shader);
        _this._pAddPass(_this);
        return _this;
    }
    _Render_RendererMaterial.prototype.onClear = function (event) {
        _super.prototype.onClear.call(this, event);
        this._texture.onClear(new AssetEvent(AssetEvent.CLEAR, this._renderer.texture));
        this._texture = null;
        this._renderer = null;
    };
    /**
     * @inheritDoc
     */
    _Render_RendererMaterial.prototype._pUpdateRender = function () {
        _super.prototype._pUpdateRender.call(this);
        var asset = this._asset;
        this.shader.setBlendMode(BlendMode.LAYER);
        asset.render();
        // LOL, this will broke state
        // this.shader._stage.setRenderTarget(null);
        this.requiresBlending = true;
        this.shader.setBlendMode(asset.blendMode || BlendMode.LAYER);
    };
    _Render_RendererMaterial.prototype._includeDependencies = function (shader) {
        _super.prototype._includeDependencies.call(this, shader);
        shader.uvDependencies++;
    };
    /**
     * @inheritDoc
     */
    _Render_RendererMaterial.prototype._getFragmentCode = function (regCache, sharedReg) {
        return this._texture._getFragmentCode(sharedReg.shadedTarget, regCache, sharedReg, sharedReg.uvVarying);
    };
    _Render_RendererMaterial.prototype._setRenderState = function (renderable) {
        _super.prototype._setRenderState.call(this, renderable);
        this._texture._setRenderState(renderable);
    };
    /**
     * @inheritDoc
     */
    _Render_RendererMaterial.prototype._activate = function () {
        // (<CacheRenderer> this._asset).render();
        // this.shader._stage.setRenderTarget(null);
        _super.prototype._activate.call(this);
        this._stage.context.setDepthTest(false, ContextGLCompareMode.LESS);
        this._texture.activate();
    };
    return _Render_RendererMaterial;
}(_Render_MaterialPassBase));
export { _Render_RendererMaterial };
